<style>
.preloader_container {
    display: flex;
    position: absolute;
    z-index: 1000000000;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #FFFFFF;
    align-items: center;
    align-content: center;
    text-align: center;
}
.preloader {
    width: 100%;
    height: 100%;
}
.loader {
    display: block;
    position: relative;
    left: 50%;
    top: 50%;
    width: 150px;
    height: 150px;
    margin: -75px 0 0 -75px;
    border-radius: 50%;
    border: 0px solid transparent;
    border-top-color: #9370DB;
}
.loader:before {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    background-image: url("./images/logo eda.svg");
    background-repeat: no-repeat;
    background-size: contain;
    width: 70px;
    height: 70px;
    transform: translate(-50%, -50%);
}
.loader:after {
    content: "";
    position: absolute;
    top: 15px;
    left: 15px;
    right: 15px;
    bottom: 15px;
    border-radius: 50%;
    border: 3px solid transparent;
    border-top-color: #404455;
    -webkit-animation: spin 1s linear infinite;
    animation: spin 1s linear infinite;
}
@-webkit-keyframes spin {
    0%   {
        -webkit-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
@keyframes spin {
    0%   {
        -webkit-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
</style>
<script>
</script>
<div class="preloader_container">
    <div class="preloader">
        <div class="loader"></div>
    </div>
</div>
